import { render, staticRenderFns } from "./attachments-dropdown.vue?vue&type=template&id=767df0f5&"
import script from "./attachments-dropdown.vue?vue&type=script&lang=ts&"
export * from "./attachments-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./attachments-dropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports